import React, { useEffect } from 'react'
import { useQuery } from 'react-query';
import { UserApi } from '../api';
import { Agreement } from '../model/User';
import { useModal } from './useModal';
import { useNavigate } from 'react-router-dom';

export const useRequiredAgreements = () => {
    const { data } = useQuery('user', UserApi.fetch);
    const agreements: Agreement[] = data?.agreements || [];
    const modal = useModal();
    const navigate = useNavigate();
    
    const handleCloseModal = React.useCallback(() => {
    modal.current?.close();
    }, [modal]);

    useEffect(() => {
        const requiredAgreements = agreements.filter((agreement) => agreement.required && !agreement.has_agree);
        if (requiredAgreements.length > 0) {
                modal.current?.open();
        }
    }, [navigate]);


    return { handleCloseModal, modal };
}
